module.exports = __webpack_public_path__ + "img/logo.564bfc24.webp";